<div id="loading-container">
   <h1>Loading...</h1>
   <p>Please wait while the machine loads. This may take several minutes.</p>
   <app-wait-spinner></app-wait-spinner>
</div>
